import { initializeHeader } from "./header";
import { getHtml } from "../apis/templateHtml";
import { navigate } from "../router/router";
import { startLoadingDisplay, endLoadingDisplay } from "../modules/uiManager/UiLoadingDisplay";
import { showPopupAlert } from "../modules/uiManager/UiPopup";
import { fetchFieldSurveyRequestDetail, } from "../apis/fieldSurveyRequestApi";
import { fetchOperationPermissions } from "../apis/graphqlClient";
import { getOperationPermission, setOperationPermissions, isOperationPermissionsLoaded } from "../modules/permissionManager/PermissionManager";
function toJstDateString(dateStr) {
    if (!dateStr)
        return '';
    const normalized = dateStr.replace(/\//g, '-').replace(' ', 'T') + (dateStr.includes('Z') || dateStr.includes('+') ? '' : 'Z');
    const d = new Date(normalized);
    if (isNaN(d.getTime()))
        return dateStr;
    const jst = new Date(d.getTime() + 9 * 60 * 60 * 1000);
    const y = jst.getUTCFullYear();
    const m = String(jst.getUTCMonth() + 1).padStart(2, '0');
    const day = String(jst.getUTCDate()).padStart(2, '0');
    const hh = String(jst.getUTCHours()).padStart(2, '0');
    const mm = String(jst.getUTCMinutes()).padStart(2, '0');
    const ss = String(jst.getUTCSeconds()).padStart(2, '0');
    return `${y}/${m}/${day} ${hh}:${mm}:${ss}`;
}
let documentRows = [];
function escapeHtml(str) {
    if (!str)
        return '';
    const div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
}
function populateForm(data) {
    const setVal = (id, val) => {
        const el = document.getElementById(id);
        if (el)
            el.value = String(val ?? '');
    };
    setVal('lblStatus', data.statusName);
    setVal('lblInternalId', data.internalId);
    setVal('lblRequestCount', data.requestCount);
    setVal('lblRequestDate', data.requestDate);
    setVal('lblHandlingType', data.handlingTypeName);
    setVal('lblCandidateId', data.candidateId);
    setVal('lblStoreNo', data.storeNo);
    setVal('lblStoreName', data.storeName);
    setVal('lblStoreNameKana', data.storeNameKana);
    setVal('lblPrefecture', data.prefectureName);
    setVal('lblZO', data.zoName || data.zo);
    setVal('lblDO', data.doName || data.do);
    setVal('lblAddress', data.address);
    setVal('lblContractType', data.contractTypeName);
    setVal('lblOwnership', data.ownershipName);
    setVal('lblBuildingType', data.buildingTypeName);
    setVal('lblLicense', data.licenseName);
    setVal('lblOpenDate', data.openDate);
    setVal('lblSurveyDesiredDate', data.surveyDesiredDate);
    setVal('lblReportDueDate', data.reportDueDate);
    setVal('lblSubmissionMethod', data.submissionMethodName);
    setVal('lblRetryReason', data.retryReason);
    setVal('lblRemarks', data.remarks);
    setVal('lblRequesterCode', data.requesterCode);
    setVal('lblRequester', data.requesterName);
    setVal('lblApproverCode', data.approverCode);
    setVal('lblApprover', data.approverName);
    setVal('lblDmCode', data.dmCode);
    setVal('lblDm', data.dmName);
    setVal('lblDesignOfficeCode', data.designOfficeCode);
    setVal('lblDesignOffice', data.designOfficeName);
    setVal('txtApprovalDept', data.approvalDept);
    setVal('txtApprovalArch', data.approvalArch);
    const chkConfirmation = document.getElementById('chkConfirmation');
    if (chkConfirmation) {
        chkConfirmation.checked = !!data.confirmation;
    }
    const boxLink = document.getElementById('lblBoxLink');
    if (boxLink) {
        if (data.boxLink) {
            boxLink.href = data.boxLink;
        }
        else {
            boxLink.style.display = 'none';
        }
    }
    const approvalBoxLink = document.getElementById('lblApprovalBoxLink');
    if (approvalBoxLink) {
        if (data.approvalBoxLink) {
            approvalBoxLink.innerHTML = `<a href="${escapeHtml(data.approvalBoxLink)}" target="_blank" class="box-link">開く</a>`;
        }
        else {
            approvalBoxLink.textContent = '―';
        }
    }
    const reportBoxLink = document.getElementById('lblReportBoxLink');
    if (reportBoxLink) {
        if (data.reportBoxLink) {
            reportBoxLink.innerHTML = `<a href="${escapeHtml(data.reportBoxLink)}" target="_blank" class="box-link">開く</a>`;
        }
        else {
            reportBoxLink.textContent = '―';
        }
    }
}
function renderDocumentTable() {
    const tbody = document.getElementById('documentTableBody');
    if (!tbody)
        return;
    let html = '';
    documentRows.forEach((row) => {
        html += `
      <tr>
        <td><span>${escapeHtml(row.documentName)}</span></td>
        <td>${escapeHtml(row.fileName)}</td>
        <td>${escapeHtml(row.uploader)}</td>
        <td>${escapeHtml(row.uploadDate)}</td>
        <td>
          <button type="button" class="pill-button-outline" disabled style="padding: 4px 12px; font-size: 12px; opacity: 0.5;">
            <span class="material-icons" style="font-size: 14px;">upload_file</span>選択
          </button>
        </td>
        <td>
          ${row.fileName
            ? `<button type="button" disabled style="background:none;border:none;color:#999;opacity:0.5;">
                <span class="material-icons">delete</span>
              </button>`
            : ''}
        </td>
      </tr>
    `;
    });
    tbody.innerHTML = html;
}
function setupButtons() {
    const btnBack = document.getElementById('btnBack');
    if (btnBack) {
        btnBack.addEventListener('click', (e) => {
            e.preventDefault();
            navigate('/field-survey-request-list');
        });
    }
}
export const initializeFieldSurveyRequestHistory = async (requestId) => {
    try {
        startLoadingDisplay();
        const content = await getHtml('/parts/fieldSurveyRequestHistory.html');
        const subContents = document.getElementById('subContents');
        if (content && subContents) {
            subContents.innerHTML = content;
        }
        await initializeHeader('現地調査依頼');
        if (!isOperationPermissionsLoaded()) {
            const ops = await fetchOperationPermissions();
            setOperationPermissions(ops);
        }
        const op = getOperationPermission('SITE_SURVEY');
        if (op && !op.ssHistory) {
            endLoadingDisplay();
            await showPopupAlert({ text: '履歴参照の権限がありません。', showBackdrop: true });
            navigate('/fieldSurveyRequest');
            return;
        }
        if (requestId) {
            const detail = await fetchFieldSurveyRequestDetail(requestId);
            populateForm(detail);
            if (detail.documents && detail.documents.length > 0) {
                documentRows = detail.documents.map(d => ({
                    documentName: d.documentName,
                    fileName: d.fileName,
                    uploader: d.uploader,
                    uploadDate: toJstDateString(d.uploadDate),
                }));
            }
            renderDocumentTable();
        }
        setupButtons();
        endLoadingDisplay();
    }
    catch (error) {
        console.error('履歴参照画面の初期化に失敗しました:', error);
        endLoadingDisplay();
        throw error;
    }
};
